/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import LZString from "lz-string";

export default class PrintWithWindow {
  constructor() {
    try {
      document.getElementById("spinner-container").style.display = "flex";
      this._getBlobUrl().then(url => {
        const ifrm = document.createElement("iframe");
        ifrm.id = "newPrintFrame";
        ifrm.style.border = "none";
        ifrm.style.display = "none";
        ifrm.style.height = "100vh";
        ifrm.style.width = "100%";
        ifrm.src = url;
        ifrm.onload = this.print;
        document.body.appendChild(ifrm);
      });
    } catch (err) {}
  }

  _getHashFragment = () => {
    let param;
    const dict = {};
    const url = window.location.hash;
    const hashIndex = url.indexOf("#");
    if (hashIndex !== -1) {
      const hashFragment = url.slice(hashIndex + 1);
      if (hashFragment !== "") {
        param = hashFragment.split("=");
        if (param.length === 2) {
          dict[param[0]] = decodeURIComponent(param[1].replace(/\+/g, " "));
        }
      }
    }
    return dict;
  };

  _getBlobUrl = async () => {
    let { url } = this._getHashFragment();
    url = LZString.decompressFromEncodedURIComponent(url);
    const resp = await fetch(url);
    const buffer = await resp.arrayBuffer();
    const blob = new Blob([buffer], {
      type: "application/pdf"
    });

    return URL.createObjectURL(blob);
  };

  print() {
    setTimeout(() => {
      const pf = document.getElementById("newPrintFrame");
      pf.contentWindow.focus();
      pf.contentWindow.print();
      document.getElementById("spinner-container").style.display = "none";
    }, 10);
  }
}
